import "./index.scss";
import axios from "axios";
import moment from "moment";
import {
  Icon, Divider, Segment, Container, Grid, GridColumn, Header,
  TableRow,
  TableHeaderCell,
  TableHeader,
  TableCell,
  TableBody,
  Table, GridRow, Search, Button, Label
} from 'semantic-ui-react'
import { useState, useEffect } from 'react'
import ExcelJS from 'exceljs';

function Case() {

  const [sent, setSent] = useState(0);
  const [neg, setNeg] = useState(0);
  const [waiting, setWaiting] = useState(0);
  const [listUpdated, setListUpdated] = useState([])
  const [listReopenUpdated, setListReopenUpdated] = useState([])
  const headersReopen = [
    { label: "Data de Reabertura", key: "reopen_date" },
    { label: "Empresa", key: "corporate_name" },
    { label: "CNPJ", key: "root_cnpj" }
  ];
  const [data, setData] = useState({
    1: { total: 0, attempts: [0, 0, 0] },
    2: { total: 0, attempts: [0, 0, 0] },
    7: { total: 0, attempts: [0, 0, 0] }
  });

  async function exec4() {
    const response = await axios.post("/case/attempts-dashboard");
    const rawData = response.data;

    const processedData = {
      1: { total: 0, attempts: [0, 0, 0] },
      2: { total: 0, attempts: [0, 0, 0] },
      7: { total: 0, attempts: [0, 0, 0] }
    };

    rawData.forEach(item => {
      if (processedData[item.status_cases_id]) {
        processedData[item.status_cases_id].total += item.total;
        processedData[item.status_cases_id].attempts[item.attempts - 1] = item.total;
      }
    });

    setData(processedData);
  };

  async function exec3() {

    const response = await axios.post("/case/reopen-cases-updated");
    setListReopenUpdated(response.data)
    console.log(response.data)
  }

  async function exec2() {

    const response = await axios.post("/case/last-cases-updated");
    setListUpdated(response.data)
    console.log(response.data)
  }

  async function exec() {
    const response = await axios.post("/case/dashboard");
    let data = response.data
    console.log(data)
    for (var i = 0; i < data.length; i++) {
      switch (data[i]['status_cases_id']) {
        case 1:
          setSent(data[i]['total']);
          break;
        case 2:
          setNeg(data[i]['total']);
          break;
        case 7:
          setWaiting(data[i]['total']);
          break;
      }
      console.log(data[i]['status_cases_id'])
    }
  }


  const handleExportUpdated = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Updated Cases');

    worksheet.columns = [
      { header: 'Status', key: 'description_system', width: 30 },
      { header: 'Empresa', key: 'corporate_name', width: 30 },
      { header: 'CNPJ', key: 'cnpj', width: 20 }
    ];

    listUpdated.forEach(item => {
      worksheet.addRow({
        description_system: item.description_system,
        corporate_name: item.corporate_name,
        cnpj: item.cnpj,
      });
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'ultimos_casos_atualizados.xlsx';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };


  const handleExportReopenUpdated = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Reopen Cases');

    worksheet.columns = [
      { header: 'Data Reabertura', key: 'reopen_date', width: 30 },
      { header: 'Empresa', key: 'corporate_name', width: 30 },
      { header: 'CNPJ Raiz', key: 'root_cnpj', width: 20 }
    ];

    listReopenUpdated.forEach(item => {
      worksheet.addRow({
        reopen_date: moment(item.reopen_date).format('DD/MM/YYYY'),
        corporate_name: item.corporate_name,
        root_cnpj: item.root_cnpj,
      });
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'casos_para_reabrir.xlsx';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };


  useEffect(() => {
    exec()
    exec2()
    exec3()
    exec4()
  }, []);


  return (
    <>
      <Container fluid className="case-new">

        <Divider horizontal>
          <Header as='h4'>
            Dados
          </Header>
        </Divider>

        <Grid columns={3}>
          <Grid.Row>
            <GridColumn>
              <Segment mini textAlign="center" clearing>
                <div class="ui statistic mini">
                  <div class="label">Tentando Contato</div>
                  <div class="value">{sent}</div>
                </div>
                <div className="attempts">
                  <div className="label attempts-labels">
                    <span>1º Ciclo</span>
                    <span>2º Ciclo</span>
                    <span>3º Ciclo</span>
                  </div>
                  <div className="attempts-values">
                    <span>{data[1].attempts[0]}</span>
                    <span>{data[1].attempts[1]}</span>
                    <span>{data[1].attempts[2]}</span>
                  </div>
                </div>
              </Segment>

            </GridColumn>
            <GridColumn>
              <Segment mini textAlign="center">
                <div className="ui statistic mini">
                  <div className="label">Negociando</div>
                  <div className="value">{neg}</div>
                </div>
                <div className="attempts">
                  <div className="label attempts-labels">
                    <span>1º Ciclo</span>
                    <span>2º Ciclo</span>
                    <span>3º Ciclo</span>
                  </div>
                  <div className="attempts-values">
                    <span>{data[2].attempts[0]}</span>
                    <span>{data[2].attempts[1]}</span>
                    <span>{data[2].attempts[2]}</span>
                  </div>
                </div>
              </Segment>
            </GridColumn>
            <GridColumn>
              <Segment mini textAlign="center">
                <div class="ui statistic mini">
                  <div class="label">Aguardando Assinatura e Pagamento</div>
                  <div class="value">{waiting}</div>
                </div>
                <div className="attempts">
                  <div className="label attempts-labels">
                    <span>1º Ciclo</span>
                    <span>2º Ciclo</span>
                    <span>3º Ciclo</span>
                  </div>
                  <div className="attempts-values">
                    <span>{data[7].attempts[0]}</span>
                    <span>{data[7].attempts[1]}</span>
                    <span>{data[7].attempts[2]}</span>
                  </div>
                </div>
              </Segment>
            </GridColumn>
          </Grid.Row>
        </Grid>
        <Divider horizontal >
          <Header as='h4'>
            Últimos casos atualizados
            <Button icon onClick={handleExportUpdated} style={{ background: 'none', border: 'none' }}>
              <Icon name="download"/>
            </Button>
          </Header>
        </Divider>
        <Table celled>
          <TableHeader>
            <TableRow>
              <TableHeaderCell>Status</TableHeaderCell>
              <TableHeaderCell>Empresa</TableHeaderCell>
              <TableHeaderCell>CNPJ</TableHeaderCell>
              <TableHeaderCell>Ciclo</TableHeaderCell>
            </TableRow>
          </TableHeader>

          <TableBody>
            {listUpdated.map(r => {
              return (

                <TableRow>
                  <TableCell>
                    {r['description_system']}
                  </TableCell>
                  <TableCell>{r['corporate_name']}</TableCell>
                  <TableCell>{r['cnpj']}</TableCell>
                  <TableCell>{r['attempts']}</TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
        <Divider horizontal >
          <Header as='h4'>
            Casos que estão para reabrir
            <Button icon onClick={handleExportReopenUpdated} style={{ background: 'none', border: 'none' }}>
              <Icon name="download" />
            </Button>
          </Header>
        </Divider>
        <Table celled>
          <TableHeader>
            <TableRow>
              <TableHeaderCell>Data Reabertura</TableHeaderCell>
              <TableHeaderCell>Empresa</TableHeaderCell>
              <TableHeaderCell>CNPJ Raiz</TableHeaderCell>
              <TableHeaderCell>Ciclo</TableHeaderCell>
            </TableRow>
          </TableHeader>

          <TableBody>
            {listReopenUpdated.map(r => {
              return (

                <TableRow>
                  <TableCell>{moment(r['reopen_date']).format('DD/MM/YYYY')}</TableCell>
                  <TableCell>{r['corporate_name']}</TableCell>
                  <TableCell>{r['root_cnpj']}</TableCell>
                  <TableCell>{r['attempts']}</TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>




      </Container>

    </>
  )
}

export default Case;